import HasLabel from './HasLabel';
import { Team } from './Team';

export interface User {
    userName: string;
    initials: string;
    infinitrakApiKey: string;
    firstName: string;
    lastName: string;
    npiNumber: string;
    teams: Team[];
    licenses: UserComplianceLicense[];
}

export class User extends HasLabel {
    constructor(obj?: User) {
        super();
        this.userName = "";
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toString(): string {
        if (this.lastName && this.firstName)
            return `${this.firstName} ${this.lastName}`;
        return this.userName;
    }
}

export interface UserComplianceLicense {
    active: boolean;
    state: string;
    licenseNumber: string;
    startDate?: Date;
    endDate?: Date;
}